import { Skeleton } from "@commonlibs";
import styled, { css } from "styled-components";
import OutlinedCard from "../OutlinedCard/OutlinedCard";

export const AttributeCardRoot = styled(OutlinedCard)(({ theme }) => {
    return css`
        padding: ${theme.spacing[5]};
        flex: 1;
    `;
});

export const AttributeSkeleton = styled(Skeleton)(() => {
    return css`
        height: 1.5rem;
        width: 4rem;
    `;
});

export const AttributePopoverContent = styled.div(() => {
    return css`
        padding: 0.5rem 1rem;
        max-width: 250px;
    `;
});
